import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../helper/httpService';
import { Constants } from '../helper/constants';

@Injectable()
export class AlertsService {
  private alertsUrl = Constants.serverUrl + 'api/alerts/';

  constructor(public http: HttpService) {
  }

  /** getAlerts */
  getAlerts(pcnNumber: string): Observable<any> {
    return this.http.Get(this.alertsUrl +
      'getAlerts' +
      '/' +
      pcnNumber
    );
  }

  /** getCustomParagraphs */
  getCustomParagraphs(pcnNumber: string): Observable<any> {
    return this.http.Get(this.alertsUrl +
      'getCustomParagraphs' +
      '/' +
      pcnNumber
    );
  }

  /** getCustomLetters */
  getCustomLetters(pcnNumber: string): Observable<any> {
    return this.http.Get(this.alertsUrl +
      'getCustomLetters' +
      '/' +
      pcnNumber
    );
  }

  /** addRemoveParagraph */
  addRemoveParagraph(alertId: number): Observable<any> {
    return this.http.Get(this.alertsUrl +
      'addRemoveParagraph' +
      '/' +
      alertId
    );
  }

  /** addRemoveCustomLetter */
  addRemoveCustomLetter(alertId: number, isRemove: boolean): Observable<any> {
    return this.http.Get(this.alertsUrl +
      'addRemoveCustomLetter' +
      '/' +
      alertId +
      '/' +
      isRemove
    );
  }

  /** getSelectedAlerts */
  getSelectedAlerts(): Observable<any> {
    return this.http.Get(this.alertsUrl +
      'getSelectedAlerts'
    );
  }


}
